import { CONFIG } from '../config';
import type { ConnectionData } from '../types';

export class ServerAPI {
  private readonly apiBase: string;

  constructor(apiBase: string = CONFIG.API_BASE) {
    this.apiBase = apiBase;
  }

  async createConnection(
    offer: RTCSessionDescriptionInit,
    iceCandidates: RTCIceCandidateInit[]
  ): Promise<{ connectionId: string }> {
    const response = await fetch(this.apiBase, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        offer,
        iceCandidates,
      }),
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Server error: ${response.status} ${response.statusText} - ${errorText}`);
    }

    return response.json();
  }

  async sendAnswer(
    connectionId: string,
    answer: RTCSessionDescriptionInit,
    iceCandidates?: RTCIceCandidateInit[]
  ): Promise<{ success: boolean }> {
    const response = await fetch(this.apiBase, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        connectionId,
        answer,
        iceCandidates,
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to send answer: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }

  async getConnection(connectionId: string): Promise<ConnectionData> {
    const response = await fetch(`${this.apiBase}?id=${connectionId}`);
    
    if (!response.ok) {
      throw new Error(`Failed to get connection: ${response.status} ${response.statusText}`);
    }

    return response.json();
  }

  async deleteConnection(connectionId: string): Promise<void> {
    const response = await fetch(`${this.apiBase}?id=${connectionId}`, {
      method: "DELETE",
    });

    if (!response.ok) {
      throw new Error(`Failed to delete connection: ${response.status} ${response.statusText}`);
    }
  }
}